import { Box, Container, Text } from '@chakra-ui/react';

import Heading from '@/components/atomic/v1/heading/Heading';
import { MyOmersBffSystemErrorLog } from '@/server/types';

interface InternalServerErrorProps {
  errorLog: MyOmersBffSystemErrorLog;
  errorMessage: string;
}

/**
 * Container that can be used to substitute a page when we receive an error
 * during server side rendering.
 *
 * Note: This is _specifically_ for SSR, and should not be used for error responses
 * from tRPC procedures.
 */
const InternalServerErrorContainer = ({ errorMessage, errorLog }: InternalServerErrorProps) => {
  return (
    <Container maxW="container.2xl" py={8}>
      <Heading as="h1" styleType="2xl">
        Internal Server Error
      </Heading>

      <Text>{errorMessage}</Text>
      <Text color="text/secondary">Error Code: {errorLog.message.code}</Text>
      <Text color="text/secondary">Correlation ID: {errorLog.message.correlationId}</Text>

      {process.env.NEXT_PUBLIC_APP_ENV !== 'prod' && (
        <Box my="8" overflowX="scroll" fontSize="small">
          <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(errorLog, null, 2)}</pre>
        </Box>
      )}
    </Container>
  );
};

export default InternalServerErrorContainer;
